import { render, staticRenderFns } from "./ModalWarning.vue?vue&type=template&id=1ba3bf41&scoped=true&"
import script from "./ModalWarning.vue?vue&type=script&lang=js&"
export * from "./ModalWarning.vue?vue&type=script&lang=js&"
import style0 from "./ModalWarning.vue?vue&type=style&index=0&id=1ba3bf41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba3bf41",
  null
  
)

export default component.exports